import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import DomainsManagementPanel from '../../components/templates/admin/DomainsManagementPanel';

const DomainsManagementPage = () => {
  return (
    <AdminLayout>
      <DomainsManagementPanel />
    </AdminLayout>
  );
};

export default DomainsManagementPage;
